import { createFileRoute } from '@tanstack/react-router';

import { DmOfferConfirmationPage } from 'src/apps/checkout/app/pages/DmOffer.Confirmation';

export const Route = createFileRoute(
  '/_auth/_only-header/store/dm-offer/confirmation'
)({
  component: () => <DmOfferConfirmationPage />,
});
